import { CardAnim3 } from "../ItemsUI";

export default function HeroCard1() {
  return (
    <>
    <section className="edu-hero">

        {/* Background floating shapes */}
        <div className="shape star"></div>
        <div className="shape circle1"></div>
     
       
        <div className="edu-container">

          {/* LEFT AREA */}
          <div className="edu-left fadeInUp">
            <p className="edu-sub">Online E-Learning Courses</p>

            <h1 className="edu-title">
              <span className="accent">Creating</span> a Better Future<br />
              through Education
            </h1>

            <p className="edu-desc">
              It is long established fact that reader distracted
              by the readable content.
            </p>

            <div className="edu-cta">
              <button className="btn-primary">All Courses</button>
              <button className="btn-outline">Contact Us</button>

              <div className="edu-avatars">
                <img src="https://i.pravatar.cc/100?img=1" />
                <img src="https://i.pravatar.cc/100?img=2" />
                <img src="https://i.pravatar.cc/100?img=3" />
                <span>24k+ Happy Students</span>
              </div>
            </div>
          </div>

          {/* RIGHT AREA */}
          <div className="edu-right">

           <CardAnim3 id={{}} settings={{}} data={{ 
            imgSrc:"https://i.postimg.cc/NjR1gXDD/young-tender-curly-girl-holding-documents-removebg-preview.png",


           }} />
          </div>
        </div>
      </section>

      <style>{`
/* ROOT SECTION */
.edu-hero {
  background: #022e35;
  padding: 50px 0;
  color: #fff;
  position: relative;
  font-family: Inter,sans-serif;
}


.star {
  width: 80px;
  height: 80px;
  
  background-size: contain;
  right: 140px;
  top: 120px;
  animation: float 5s ease-in-out infinite;
}


/* CONTAINER */
.edu-container {
  width: 88%;top:-70px;
  max-width: 1250px;
  margin: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  position: relative;
  z-index: 5;
}

/* LEFT */
.edu-sub { opacity: .75; font-size: 15px; }

.edu-title {
  font-size: 60px;
  line-height: 1.15;
  font-weight: 800;
  margin-bottom: 20px;
}

.accent { color: #2b8aff; }

.edu-desc {
  opacity: .85;
  width: 80%;
  margin-bottom: 30px;
}

.edu-cta {
  display: flex;
  align-items: center;
  gap: 20px;
}

.btn-primary {
  background: #2b8aff;
  padding: 12px 32px;
  border-radius: 30px;
  border: none;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}

.btn-outline {
  padding: 12px 32px;
  border-radius: 30px;
  border: 2px solid rgba(255,255,255,0.3);
  background: transparent;
  color: #fff;
  cursor: pointer;
}

.edu-avatars {
  display: flex;
  align-items: center;
  margin-left: 20px;
}
.edu-avatars img {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 2px solid #fff;
  margin-left: -10px;
}
.edu-avatars span { margin-left: 15px; opacity: .9; }

/* RIGHT */
.edu-right { display:flex; justify-content:center; }

/* Responsive */
@media (max-width: 768px) {
.edu-right {transform:scale(1.2);  position:relative;top:90px;left:-20px;}
.edu-hero {
 
  padding: 0px 0;
 
}
/* CONTAINER */
.edu-container {
  width: 100%; left:-10%;top:-150px;
 transform:scale(0.7);
  grid-template-columns: 1fr ;
  
}
}
      `}</style>
    </>
  );
}
